import Loadable from 'react-loadable';

export const LabelEmbed = Loadable({
  loader: () => import(/* webpackChunkName: "RelayLabelEmbed" */ './LabelEmbed'),
  loading: () => null,
});

export { labelEmbedResource } from '../../resources/labelResource';
